export class BackgroundPersonSoundPlayer {
    constructor(sound) {
        this.speed = 0;
        this.sound = sound;
        this.play(0);
    }
    setSpeed(speed) {
        const prevSpeed = this.speed;
        this.speed = speed;
        if (prevSpeed === speed) {
            return;
        }
        this.play(speed);
    }
    play(speed) {
        if (speed === 0) {
            if (this.sound.isPlayingLoop("runningGrandpas")) {
                this.sound.stopLoop("runningGrandpas");
            }
            this.sound.playLoop("runningGrandpas", { volume: 0.125 });
        }
        else if (speed === 1) {
            if (this.sound.isPlayingLoop("runningGrandpas")) {
                this.sound.stopLoop("runningGrandpas");
            }
            this.sound.playLoop("runningGrandpas", { volume: 0.25 });
        }
        else if (speed === 2) {
            if (this.sound.isPlayingLoop("runningGrandpas")) {
                this.sound.stopLoop("runningGrandpas");
            }
            this.sound.playLoop("runningGrandpas", { volume: 0.5 });
        }
        else if (speed === 3) {
            if (this.sound.isPlayingLoop("runningGrandpas")) {
                this.sound.stopLoop("runningGrandpas");
            }
            this.sound.playLoop("runningGrandpas");
        }
        else if (speed === 4) {
            if (this.sound.isPlayingLoop("runningGrandpas")) {
                this.sound.stopLoop("runningGrandpas");
            }
            this.sound.playLoop("runningGrandpas", { volume: 0.25 });
        }
    }
    dispose() {
        if (this.sound.isPlayingLoop("runningGrandpas")) {
            this.sound.stopLoop("runningGrandpas");
        }
    }
}
//# sourceMappingURL=backgroundPersonSoundPlayer.js.map